// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


const settings = {
	showOnLoad: false,
	shippingToggleButton: '.calculateshipping-button-container',
	shippingCalculatorForm: '.shipping_calculator',
	hideFields: ['#calc_shipping_country', '#calc_shipping_method'],
	processingClass: 'is-processing',
	calculatorLabel: 'Enter your postage details to calculate',
	animationTransition: 300
};


export default class ShippingCalculator {

    constructor() {

    	this.cache();

    	// set our initial calculator state
    	this.setInitialState();

    	if( this.cache.form.length ) {
    		this.events();
    	}

    }

    cache() {
    	this.cache = {};
    	this.cache.shippingButton = $(settings.shippingToggleButton);
    	this.cache.form = $(settings.shippingCalculatorForm);
		this.cache.expandableContainer = this.cache.form.find('.shipping-calculator-form');
    }

    events() {

    	// show the calculator
    	this.cache.shippingButton.on('click', this.showCalculator.bind(this));

    	// process our shipping
    	this.cache.form.on('submit', this.processShipping.bind(this));

    }

    // set the initial settings
    setInitialState() {

    	this.addResultList();

    	this.addCalculatorLabel();

    	this.hideFields();

        // quickfix select
        this.cache.form.find('select').closest('p').addClass('select');

    	// show our form if enabled
    	if( settings.showOnLoad == true ) {
    		this.cache.expandableContainer.show();
    	}

		// hide our button. form already visible
		if( settings.showOnLoad == true ) {
			this.cache.shippingButton.hide();
		}

    }

    // hides any unrequired elements
    hideFields() {

		$.each(settings.hideFields, function(index, element) {
			$(element).closest('p').hide();
		});

    }

    showCalculator(e) {
		if (e & e.preventDefault !== undefined) {
			e.preventDefault();
		}

    	this.cache.shippingButton.fadeOut(settings.animationTransition);

    	// change context variable
    	var context = this;

    	// slide form in after button fades out
    	setTimeout(function() {
    		context.cache.expandableContainer.slideDown(settings.animationTransition);
    	}, settings.animationTransition)

    }

    processShipping(event) {

    	event.preventDefault();

    	// add a message while we are performing calculations
    	this.cache.resultsList.html('<ul><li>Calculating Shipping&hellip;</li></ul>');

    	// add a processing state to have additional visual feedback
    	this.cache.form.addClass(settings.processingClass);

        // context.cache.resultsList.hide();

		$.ajax({
			type: 'POST',
			url: base_urls.ajaxurl,
			context: this,
			data: {
				action: 'shipping_cal',
				calc_shipping_state: $('#calc_shipping_state').val(),
				calc_shipping_city: $('#calc_shipping_city').val(),
				calc_shipping_postcode: $('#calc_shipping_postcode').val(),
				calc_shipping_country: $('#calc_shipping_country').val()
			}
		}).done(function(data) {

			this.cache.resultsList.html('<ul></ul>');

			// return if no data found
			if( ! data ) {
				this.cache.resultsList.html('<ul><li class="error">An error occured. Please try again</li></ul>');
				return;
			}

			// change context variable
			var context = this;

			data.forEach(function(value) {
				if(value.cost) {
					context.cache.resultsList.find('ul').append('<li class="success"><a href="'+base_urls.site_url+'/cart">Your Cart</a> with <strong>' + value.title + '</strong>: ' + value.cost + '</li>')
				    // context.cache.resultsList.hide();
                } else {
					context.cache.resultsList.find('ul').append('<li><strong>' + value.title + '</strong></li>')
				}
			});

			this.cache.form.removeClass(settings.processingClass);

		});

    }

    // add our results list
    addResultList() {
    	this.cache.resultsList = $('<div id="ajax-list-options"></div>');
    	this.cache.expandableContainer.prepend(this.cache.resultsList);
    }

    // add our calculator label
    addCalculatorLabel() {
    	if( typeof settings.calculatorLabel != 'undefined' ) {
    		this.cache.expandableContainer.prepend('<label class="shipping-label">'+settings.calculatorLabel+'</label>');
    	}
    }

}
